module.exports = __webpack_public_path__ + "img/marqueetino-img.5c7295c8.webp";